export const portalRootNode = document.getElementById("portal-root")!;
